import { Fragment as e, jsx as t, jsxs as n } from "react/jsx-runtime";
//#region src/components/selects/SelectedOption.tsx
var r = (r) => {
	let { label: i, placeholder: a, selectedOptionText: o, selectedItem: s, options: c, showSelectedItemIcon: l, showUnselectedItemIcons: u } = r, d = (n, r) => {
		let i = n.filter((e) => !e.header).map((e) => /* @__PURE__ */ t("span", {
			className: `selected-option-icon ${r && r.id === e.id ? "" : "inactiveIcon"}`,
			children: e.icon
		}, e.id));
		return /* @__PURE__ */ t(e, { children: i });
	};
	return /* @__PURE__ */ n("span", {
		className: "selected-option",
		children: [!o && i && /* @__PURE__ */ n("span", {
			className: "selected-option-label",
			children: [i, ":"]
		}), /* @__PURE__ */ t("span", {
			className: "selected-option-content",
			children: o ? /* @__PURE__ */ t("span", {
				className: "selected-option-text",
				children: o
			}) : ((r, i) => u ? d(c, r) : r ? /* @__PURE__ */ n(e, { children: [r.icon && /* @__PURE__ */ t("span", {
				className: "selected-option-icon",
				children: r.icon
			}), !l && /* @__PURE__ */ t("span", {
				className: "selected-option-text",
				children: r.label
			})] }) : /* @__PURE__ */ t("span", {
				className: "selected-option-text",
				children: i ? /* @__PURE__ */ t("span", {
					className: "placeholder",
					children: i
				}) : "\xA0"
			}))(s, a)
		})]
	});
};
//#endregion
export { r as default };

//# sourceMappingURL=SelectedOption.js.map